var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;
var _ = bookedby.deps != null ? bookedby.deps._ : global._;

var ServiceModel = require('../../app/models/service');
var CategoryModel = require('../../app/models/category');
var RitualModel = require('../../app/models/ritual');
var EmployeeModel = require('../../app/models/employee');

var ServiceManager = function() {
  this.init();
  _.extend(this, Backbone.Events);
};


ServiceManager.prototype = {
  init: function() {
    this.allCategories = new Backbone.Collection(bookedby.staticData.serviceCategories, { model: CategoryModel });

    this.allServices = new Backbone.Collection(bookedby.staticData.centralServices, {
      model: ServiceModel,
      comparator: function(x) { return x.get('name'); }
    });

    this.serviceMap = {};
    this.allServices.each(_.bind(function(service) {
      this.serviceMap[service.get('id')] = service;
    }, this));

    this.allRituals = new Backbone.Collection(bookedby.staticData.avedaRituals, { model: RitualModel });

    this.ritualMap = {};
    this.allRituals.each(_.bind(function(ritual) {
      this.ritualMap[ritual.get('id')] = ritual;
    }, this));

    this.allEmployees = new Backbone.Collection([], {
      model: EmployeeModel,
      comparator: function(x) { return x.get('name'); }
    });
    this.employeeMap = {};

    this.addonServicesMap = {};
    this.recommendedServicesMap = {};
    this.requiredServicesMap = {};

    this.employeeWaitTimesMap = {};
    this.employeeByGuestWaitTimes = {};
    this.employeesWithWorkSchedule = {};

    this.haveServiceDetails = false;

    /** Quick fix for the  **/
    this.hasAllServices = false;
  },

  bindServiceDetails: function(data, hasAllServices) {

    this.hasAllServices = hasAllServices !== false;

    this.allServices.each(function(service) {
      service.set('active', false);
    });

    _.each(data.services, _.bind(function(serviceData) {
      var service = this.serviceMap[serviceData.centralServiceId];
      if (service != null) {
        service.set({
          active: true,
          minPrice: serviceData.minPrice,
          maxPrice: serviceData.maxPrice,
          minDuration: serviceData.minDuration,
          maxDuration: serviceData.maxDuration,
          hasPrice: serviceData.minPrice != null,
          hasDurations: serviceData.minDuration != null,
          isAddon: serviceData.isAddon,
          description: serviceData.description // force store service description instead of central service description. BB-1120
        });

        // force store service name or client facing name instead of central service name
        if (!_.isEmpty(serviceData.clientName))
          service.set('name', serviceData.clientName);
        else if (!_.isEmpty(serviceData.name))
          service.set('name', serviceData.name);
      }
    }, this));

    this.allEmployees.reset(data.employees);
    this.allEmployees.sort(function(x, y) {
      return 0;
    });
    this.employeeMap = {};
    this.allEmployees.each(_.bind(function(employee) {
      this.employeeMap[employee.get('id')] = employee;
    }, this));

    this.serviceDetails = {};
    this.centralServiceToService = {};
    _.each(data.serviceDetails, _.bind(function(serviceDetail) {
      var key = serviceDetail.centralServiceId + '|' + serviceDetail.employeeId;
      this.serviceDetails[key] = {
        price: serviceDetail.price,
        duration: serviceDetail.duration,
        afterDuration:  serviceDetail.afterDuration
      };

      this.centralServiceToService[serviceDetail.centralServiceId] = serviceDetail.employeeId;

    }, this));

    this.addonServicesMap = {};
    if (data.addonServices) {
      this.addonServicesMap = data.addonServices;
    }
    this.recommendedServicesMap = {};
    if (data.recommendedServices) {
      this.recommendedServicesMap = data.recommendedServices;
    }
    this.requiredServicesMap = {};
    if (data.requiredServices) {
      this.requiredServicesMap = data.requiredServices;
    }

    if (data.employeeSchedules) {
      this.employeesWithWorkSchedule = data.employeeSchedules;
    } else {
      this.employeesWithWorkSchedule = {};
    }

    this.haveServiceDetails = true;
  },

  bindEmployeeWaitTimes: function(data) {
    this.employeeWaitTimesMap = {};
    _.each(data, _.bind(function(employee) {
      this.employeeWaitTimesMap[+employee.employeeId] = employee;
    }, this));
    this.trigger('waitTimesUpdated');

  },

  bindGuestWaitTimes: function(guests) {
    this.employeeByGuestWaitTimes = {};

    var guestIndex = 0;

    _.each(guests, _.bind(function(guest) {
      this.employeeByGuestWaitTimes[guestIndex] = {};
      _.each(guest, _.bind(function(employee) {
        this.employeeByGuestWaitTimes[guestIndex][+employee.employeeId] = employee;
      }, this));
      guestIndex++;
    }, this));
    this.trigger('employeeByGuestWaitTimesUpdated');
  },

  /**
   * Resets employees with data
   * @param {array} data
   */
  setEmployees: function(data) {
    this.allEmployees.reset(data);
    this.employeeMap = {};
    this.allEmployees.each(_.bind(function(employee) {
      this.employeeMap[employee.get('id')] = employee;
    }, this));
  },

  /**
   * Resets serviceDetails with data
   * @param {array} data
   */
  setServiceDetails: function(data) {
    this.serviceDetails = {};
    this.centralServiceToService = {};
    _.each(data, _.bind(function(serviceDetail) {
      var key = serviceDetail.centralServiceId + '|' + serviceDetail.employeeId;
      this.serviceDetails[key] = {
        price: serviceDetail.price,
        duration: serviceDetail.duration
      };
      if (!_.isUndefined(serviceDetail.isAddon)) {
        this.serviceMap[serviceDetail.centralServiceId].set('isAddon', serviceDetail.isAddon);
      }
      this.centralServiceToService[serviceDetail.centralServiceId] = serviceDetail.storeServiceId;
    }, this));

    this.haveServiceDetails = true;
  },

  setAddons: function(data) {
    this.addonServicesMap = {};
    if (data) {
      this.addonServicesMap = data;
    }
  },

  clearServiceDetails: function() {
    if (!this.haveServiceDetails) {
      return;
    }

    this.allEmployees.reset([]);
    this.employeeMap = {};

    this.allServices.each(function(service) {
      service.set({
        active: true,
        minPrice: null,
        maxPrice: null,
        hasPrice: false,
        minDuration: null,
        maxDuration: null,
        hasDurations: false
      });
    });


    this.serviceDetails = {};
    this.centralServiceToService = {};

    this.haveServiceDetails = false;
  },

  employeeHasService: function(employee, service) {
    var key = service.get('id') + '|' + employee.get('id');
    return _.has(this.serviceDetails, key);
  },

  employeePrice: function(employee, service) {
    var key = service.get('id') + '|' + employee.get('id');
    var serviceDetail = this.serviceDetails[key];
    return (serviceDetail == null) ? null : serviceDetail.price;
  },

  employeeDuration: function(employee, service) {
    var key = service.get('id') + '|' + employee.get('id');
    var serviceDetail = this.serviceDetails[key];
    return (serviceDetail == null) ? null : serviceDetail.duration;
  },

  employeeAfterDuration: function(employee, service) {
    var key = service.get('id') + '|' + employee.get('id');
    var serviceDetail = this.serviceDetails[key];
    return (serviceDetail == null) ? null : serviceDetail.afterDuration;
  },


  checkStoreHasAllServices: function(storeId, services) {

    var selectedServices = services;
    var selectedAddons = [];

    if(selectedServices.length > 0) {
      return $.ajax({
        url: bookedby.routes.BOOKING.GET_SINGLE_STORE_INFO,
        contentType: 'application/json',
        cache: false,
        data: {
          storeGroupUuid: bookedby.staticData.storeGroupId,
          storeId: storeId
        },
        method: 'GET',
        dataType: 'json'

      }).then(function(data) {

        if (data.success) {
          var missingAddons = false;

          // get all service id's for the new store (without addons)
          var primaryServices = _.filter(data.services, function(service) { return service.isAddon == false; });
          var allServiceIds = _.pluck(primaryServices, 'centralServiceId');

          var validServices = [];
          // find if selected services also exist on new store
          _.each(selectedServices, function(selService) {
            var validAddons = [];
            // if != null -> service is available
            if (_.contains(allServiceIds, selService.get("service").get('id'))) {
              validServices.push(selService);

              // if service is valid, must check selected addons
              selService.addonCollection.each(function(addon) {
                if(addon.get('selectedService') != null) {
                  var parentId = selService.get("service").get('id');
                  if(data.addonServices.hasOwnProperty(parentId)) {
                    if (addon.get("selectedService") == 0) {
                      var found = true;
                    } else {
                      found = _.find(data.addonServices[parentId], function(newAddon) {
                        return newAddon.centralServiceId == addon.get("selectedService").get("id");
                      });
                    }
                    if(found) {
                      validAddons.push(addon);
                    }
                  }
                }
              });
              var selectedAddons = selService.addonCollection.filter(function(addon) {
                return addon.get('selectedService') != null;
              });
              if(validAddons.length < selectedAddons.length) {
                missingAddons = true;
              }
              selService.addonCollection.reset(validAddons);
            }
          });

          var hasAllServices = validServices.length == selectedServices.length && !missingAddons;

          return {
            hasAllServices: hasAllServices,
            validServices: validServices
          };

        } else {
          bookedby.app.logAPIError(data.error);
          return null;
        }

      }).fail(_.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
      }, this));

    } else {
      return {};
    }
  },

  getRequiredServices: function(service) {
    if (service == null) {
      return [];
    }
    var requiredArray = this.requiredServicesMap[service.get('id')];
    if (requiredArray != null) {
      return _.map(requiredArray, _.bind(function(rService) {
        return this.serviceMap[rService.centralServiceId];
      }, this)).filter(function(rService) {
        return !rService.get('isAddon');
      });
    } else {
      return [];
    }

  }

};


module.exports = ServiceManager;
